module.exports = __webpack_public_path__ + "img/MultipleSelect.51e5fd50.svg";